import { useEffect } from 'react';

const NavScrollHandler = () => {
    useEffect(() => {
        console.log('NavScrollHandler mounted!');

        // Only run on desktop
        if (window.innerWidth < 1024) {
            console.log('Not desktop, skipping scroll behavior');
            return;
        }

        let navHeight = 150;
        let isScrolled = false;

        const navDesktopOuter = document.querySelector('.nav-desktop-outer');
        const navScrollFixed = document.querySelector('.nav-scroll-fixed');

        console.log('Nav elements:', { navDesktopOuter, navScrollFixed });

        if (!navDesktopOuter || !navScrollFixed) {
            console.error('Navigation elements not found!');
            return;
        }

        // Get actual nav height after a short delay
        setTimeout(() => {
            navHeight = navDesktopOuter.offsetHeight || 150;
            console.log('Navigation height:', navHeight);
        }, 100);

        const handleScroll = () => {
            const scrollY = window.pageYOffset;

            if (scrollY > navHeight && !isScrolled) {
                isScrolled = true;
                console.log('Scrolled down - switching to fixed nav');

                // Temporarily disable hover-outside close during transition
                document.body.classList.add('nav-transitioning');

                navDesktopOuter.classList.add('scrolled');
                navScrollFixed.classList.add('active');

                // Check if any mega menu is currently active in PrimaryNav BEFORE we hide them
                const activeMainMenu = document.querySelector('.mega-menu.menu-active:not(.scrolled-mega-menu)');
                let menuDataToTransfer = null;

                if (activeMainMenu) {
                    menuDataToTransfer = activeMainMenu.dataset.menu;
                    console.log('Active menu found:', menuDataToTransfer);
                }

                // Remove active state from ALL unscrolled nav items
                const allUnscrolledNavItems = document.querySelectorAll('.nav-item:not(.nav-item-scroll)');
                allUnscrolledNavItems.forEach((item) => {
                    item.classList.remove('nav-item-active');
                });

                // Remove menu-active class and hide ALL unscrolled mega menus
                const allUnscrolledMenus = document.querySelectorAll('.mega-menu:not(.scrolled-mega-menu)');
                allUnscrolledMenus.forEach((menu) => {
                    menu.classList.remove('menu-active', 'opacity-100');
                    menu.classList.add('opacity-0', 'hidden');
                });

                // If there was an active menu, open the corresponding scrolled mega menu
                if (menuDataToTransfer) {
                    const scrolledMenu = document.querySelector(`.scrolled-mega-menu[data-menu="${menuDataToTransfer}"]`);
                    if (scrolledMenu) {
                        scrolledMenu.classList.remove('opacity-0', 'hidden');
                        scrolledMenu.classList.add('menu-active', 'opacity-100');
                        navScrollFixed.classList.add('scrolled-mega-menu-active');

                        // Add active state to corresponding nav item
                        const scrollNavItem = document.querySelector(`.nav-item-scroll[data-nav="${menuDataToTransfer}"]`);
                        if (scrollNavItem) {
                            scrollNavItem.classList.add('nav-item-active');
                        }
                    }
                }

                // Re-enable hover-outside close after transition
                setTimeout(() => {
                    document.body.classList.remove('nav-transitioning');
                }, 100);
            } else if (scrollY <= navHeight && isScrolled) {
                isScrolled = false;
                console.log('Scrolled up - switching to main nav');

                // Temporarily disable hover-outside close during transition
                document.body.classList.add('nav-transitioning');

                navDesktopOuter.classList.remove('scrolled');
                navScrollFixed.classList.remove('active');

                // Check if any scrolled mega menu is currently active
                const activeScrolledMenu = document.querySelector('.scrolled-mega-menu.menu-active');
                let menuWasActive = false;

                if (activeScrolledMenu) {
                    const menuData = activeScrolledMenu.dataset.menu;
                    console.log('Active scrolled menu found:', menuData);
                    menuWasActive = true;

                    // Find and open the corresponding main mega menu
                    const mainMenu = document.querySelector(`.mega-menu[data-menu="${menuData}"]:not(.scrolled-mega-menu)`);
                    if (mainMenu) {
                        mainMenu.classList.remove('opacity-0', 'hidden');
                        mainMenu.classList.add('menu-active', 'opacity-100');

                        // Add active state to corresponding nav item
                        const mainNavItem = document.querySelector(`.nav-item[data-nav="${menuData}"]`);
                        if (mainNavItem) {
                            mainNavItem.classList.add('nav-item-active');
                        }

                        // Keep the overlay active since we're transferring the menu
                        const main = document.querySelector('main');
                        if (main) {
                            main.classList.add('mega-menu-overlay');
                        }
                        document.body.classList.add('mega-menu-active');
                    }
                }

                // Remove active state from ALL scrolled nav items
                const allScrolledNavItems = document.querySelectorAll('.nav-item-scroll');
                allScrolledNavItems.forEach((item) => {
                    item.classList.remove('nav-item-active');
                });

                // Close all scrolled mega menus
                const menus = document.querySelectorAll('.scrolled-mega-menu');

                menus.forEach((menu) => {
                    menu.classList.remove('menu-active', 'opacity-100');
                    menu.classList.add('opacity-0', 'hidden');
                });

                // Only remove overlay if no menu was active
                if (!menuWasActive) {
                    const main = document.querySelector('main');
                    if (main) {
                        main.classList.remove('mega-menu-overlay');
                    }
                    document.body.classList.remove('mega-menu-active');
                }

                // Remove mega-menu-active class from scroll nav
                if (navScrollFixed) {
                    navScrollFixed.classList.remove('scrolled-mega-menu-active');
                }

                // Re-enable hover-outside close after transition
                setTimeout(() => {
                    document.body.classList.remove('nav-transitioning');
                }, 100);
            }
        };

        // Add scroll listener
        window.addEventListener('scroll', handleScroll);

        // Check initial scroll position
        handleScroll();

        console.log('NavScrollHandler initialized');

        // Cleanup
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // This component doesn't render anything
    return null;
};

export default NavScrollHandler;